(function () {
  var boundToggle = null;
  var toggleObserver = null;
  var boxSelectorBound = false;
  var initialCaptions = new WeakMap();
  var isApplying = false;
  var initTimer = null;
  var MAX_BOX_TOTAL = 2;
  var MAX_BOX_ITEM = 2;
  var SKIO_BOX_PRODUCT_ID = '10609918542163';
  var SKIO_BOX_VARIANT_ID = 53849809387859;
  var SKIO_SELLING_PLAN_ID = 691039568211;
  var TAB2_FL_SKIO_BOX_PRODUCT_ID = '10624849314131';
  var TAB2_FL_SKIO_BOX_VARIANT_ID = 53919346000211;
  var TAB3_FL_SKIO_BOX_PRODUCT_ID = '10624942834003';
  var TAB3_FL_SKIO_BOX_VARIANT_ID = 53919538839891;
  var cachedBoxVariantId = null;
  var cachedSkioBox = null;
  var cachedSkioBoxes = {};
  var cachedSkioBoxPromises = {};
  var isAddingToCart = false;
  var quantityTabsBound = false;
  var quantityTabFlBound = { '2': false, '3': false };
  var intervalUserChanged = false;
  var quantityTabUserChanged = false;
  var RELEVANT_SELECTOR =
    '[data-60-days-2-fl], [data-ol-1-fl], [data-ol-2-fl], [data-atc-1-fl], [data-atc-2-fl], [data-2-fl-container]';

  function getElements() {
    return {
      toggle: document.querySelector('[data-60-days-2-fl]'),
      ol1: document.querySelector('[data-ol-1-fl]'),
      ol2: document.querySelector('[data-ol-2-fl]'),
      atc1: document.querySelectorAll('[data-atc-1-fl]'),
      atc2: document.querySelectorAll('[data-atc-2-fl]'),
    };
  }

  function withDomLock(fn) {
    isApplying = true;
    try {
      fn();
    } finally {
      isApplying = false;
    }
  }

  function scheduleInit() {
    if (initTimer) clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      initTimer = null;
      init();
    }, 100);
  }

  function nodeIsRelevant(node) {
    if (!node || node.nodeType !== 1 || !node.matches) return false;
    if (node.matches(RELEVANT_SELECTOR)) return true;
    return !!node.querySelector(RELEVANT_SELECTOR);
  }

  function mutationIsRelevant(mutation) {
    if (mutation.type !== 'childList') return false;

    for (var i = 0; i < mutation.addedNodes.length; i += 1) {
      if (nodeIsRelevant(mutation.addedNodes[i])) return true;
    }

    return false;
  }

  function isExpanded(toggle) {
    if (!toggle) return false;
    if (toggle.getAttribute('aria-expanded') === 'true') return true;
    if (toggle.getAttribute('aria-expanded') === 'false') return false;

    var control = toggle.querySelector('[aria-expanded]');
    return control ? control.getAttribute('aria-expanded') === 'true' : false;
  }

  function getAtcClickTarget(el) {
    if (!el) return null;
    if (el.matches('button, a, input, [role="button"]')) return el;
    return el.querySelector('button, a, input, [role="button"]');
  }

  function setAtcDisabled(el, disabled) {
    if (!el) return;

    var clickTarget = getAtcClickTarget(el) || el;
    var isDisabled = clickTarget.getAttribute('aria-disabled') === 'true';

    if (isDisabled === disabled) return;

    if (clickTarget.matches('button, input')) {
      clickTarget.disabled = disabled;
    }

    clickTarget.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    clickTarget.style.pointerEvents = disabled ? 'none' : '';
    clickTarget.style.opacity = disabled ? '0.35' : '';
  }

  function setDisplay(nodes, value) {
    nodes.forEach(function (node) {
      if (node.style.display !== value) {
        node.style.display = value;
      }
    });
  }

  function getCaptionParagraph(atc2) {
    var caption = atc2.querySelector('[data-atc-caption]');
    if (!caption) return null;
    return caption.querySelector('p') || caption;
  }

  function rememberInitialCaptions(atc2Nodes) {
    atc2Nodes.forEach(function (atc2) {
      if (initialCaptions.has(atc2)) return;

      var captionEl = getCaptionParagraph(atc2);
      if (captionEl) {
        initialCaptions.set(atc2, captionEl.textContent.trim());
      }
    });
  }

  function getCaptionText(total, initialText) {
    return getCaptionTextForBox(total, MAX_BOX_TOTAL, initialText);
  }

  function getCaptionTextForBox(total, maxTotal, initialText) {
    if (total === 0) return initialText;
    if (total >= maxTotal) return 'Add to cart';
    if (total === maxTotal - 1) return 'pick one more flavour';
    return 'pick another 2 flavours';
  }

  function getFlPartSelector(flavorKey, part) {
    return '[data-' + part + '-' + flavorKey + '-fl]';
  }

  function getFlContainerSelector(flavorKey) {
    return '[data-' + flavorKey + '-fl-container]';
  }

  function getFlInputSelector(flavorKey) {
    return '[data-input-' + flavorKey + '-fl]';
  }

  function getContainerParts(container, flavorKey) {
    if (!flavorKey) {
      if (container.matches('[data-3-fl-container]') || container.matches('[data-input-3-fl]')) {
        flavorKey = '3';
      } else if (container.matches('[data-1-fl-container]') || container.matches('[data-input-1-fl]')) {
        flavorKey = '1';
      } else {
        flavorKey = '2';
      }
    }

    return {
      optionEl: container.querySelector(getFlPartSelector(flavorKey, 'option')),
      minus: container.querySelector(getFlPartSelector(flavorKey, 'minus')),
      quantity: container.querySelector(getFlPartSelector(flavorKey, 'quantity')),
      plus: container.querySelector(getFlPartSelector(flavorKey, 'plus')),
    };
  }

  function forEachFlContainers(root, flavorKey, fn) {
    if (!root) return;

    var containers = root.querySelectorAll(getFlContainerSelector(flavorKey));
    if (!containers.length) {
      containers = root.querySelectorAll(getFlInputSelector(flavorKey));
    }

    containers.forEach(fn);
  }

  function getQuantityDisplayEl(quantityEl) {
    if (!quantityEl) return null;
    if (quantityEl.matches('input, textarea, p, span')) return quantityEl;
    return quantityEl.querySelector('p') || quantityEl.querySelector('span') || quantityEl;
  }

  function readQuantity(quantityEl) {
    if (!quantityEl) return 0;

    var displayEl = getQuantityDisplayEl(quantityEl);

    if (displayEl.matches('input, textarea')) {
      var inputValue = parseInt(displayEl.value, 10);
      return isNaN(inputValue) ? 0 : inputValue;
    }

    var value = parseInt(displayEl.textContent, 10);
    return isNaN(value) ? 0 : value;
  }

  function writeQuantity(quantityEl, value) {
    if (!quantityEl) return;
    var next = String(value);
    var displayEl = getQuantityDisplayEl(quantityEl);

    if (displayEl.matches('input, textarea')) {
      if (displayEl.value !== next) {
        displayEl.value = next;
      }
      return;
    }

    if (displayEl.textContent.trim() !== next) {
      displayEl.textContent = next;
    }
  }

  function getTotalQuantity(root, flavorKey) {
    if (!root) return 0;
    flavorKey = flavorKey || '2';
    var total = 0;

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      total += readQuantity(parts.quantity);
    });

    return total;
  }

  function setButtonDisabled(button, disabled) {
    if (!button) return;

    var isDisabled = button.getAttribute('aria-disabled') === 'true';
    if (isDisabled === disabled) return;

    if (disabled) {
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.35';
      button.style.cursor = 'default';
    } else {
      button.style.removeProperty('pointer-events');
      button.style.removeProperty('opacity');
      button.style.removeProperty('cursor');
    }

    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function updateBoxControls(root, limits, flavorKey) {
    if (!root) return;
    flavorKey = flavorKey || '2';
    var maxTotal = limits && limits.maxTotal != null ? limits.maxTotal : MAX_BOX_TOTAL;
    var maxItem = limits && limits.maxItem != null ? limits.maxItem : MAX_BOX_ITEM;
    var total = getTotalQuantity(root, flavorKey);

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      var qty = readQuantity(parts.quantity);

      setButtonDisabled(parts.minus, qty <= 0);
      setButtonDisabled(parts.plus, total >= maxTotal || qty >= maxItem);
    });
  }

  function updateAtc2SelectionState() {
    var els = getElements();
    var total = els.ol2 ? getTotalQuantity(els.ol2) : 0;

    rememberInitialCaptions(els.atc2);

    els.atc2.forEach(function (atc2) {
      var captionEl = getCaptionParagraph(atc2);
      if (!captionEl) return;

      var initialText = initialCaptions.get(atc2) || captionEl.textContent.trim();
      var nextText = getCaptionText(total, initialText);

      if (captionEl.textContent !== nextText) {
        captionEl.textContent = nextText;
      }
    });

    if (!isExpanded(els.toggle)) return;

    els.atc2.forEach(function (atc2) {
      setAtcDisabled(atc2, total < MAX_BOX_TOTAL);
    });
  }

  function sync() {
    if (hasQuantityTabs()) return;

    withDomLock(function () {
      var els = getElements();
      var expanded = isExpanded(els.toggle);

      if (els.ol1 && els.ol1.style.display !== (expanded ? 'none' : 'flex')) {
        els.ol1.style.display = expanded ? 'none' : 'flex';
      }

      if (els.ol2 && els.ol2.style.display !== (expanded ? 'flex' : 'none')) {
        els.ol2.style.display = expanded ? 'flex' : 'none';
      }

      setDisplay(els.atc1, expanded ? 'none' : 'flex');

      if (expanded) {
        setDisplay(els.atc2, 'flex');
        if (els.ol2) {
          updateAtc2SelectionState();
        } else {
          els.atc2.forEach(function (atc2) {
            setAtcDisabled(atc2, true);
          });
        }
      } else {
        setDisplay(els.atc2, 'none');
        els.atc1.forEach(function (atc1) {
          setAtcDisabled(atc1, false);
        });
        els.atc2.forEach(function (atc2) {
          setAtcDisabled(atc2, false);
        });
      }
    });
  }

  function bindToggle(toggle) {
    if (!toggle || toggle === boundToggle) return;

    if (toggleObserver) toggleObserver.disconnect();

    boundToggle = toggle;
    toggleObserver = new MutationObserver(function () {
      if (!isApplying) sync();
    });
    toggleObserver.observe(toggle, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
      subtree: true,
    });
  }

  function parseShopifyGid(value) {
    if (value == null) return null;
    if (typeof value === 'number') return value;

    var match = String(value).match(/(\d+)$/);
    return match ? Number(match[1]) : Number(value);
  }

  function normalizeOption(value) {
    return String(value || '').trim().toLowerCase();
  }

  function findSkioVariantByOption(skioBox, option1Value) {
    var normalized = normalizeOption(option1Value);
    if (!normalized || !skioBox) return null;

    var variants = getSkioSelectableVariants(skioBox);
    var match = null;
    var i;

    for (i = 0; i < variants.length; i += 1) {
      if (normalizeOption(variants[i].productVariantTitle) === normalized) {
        return variants[i];
      }
    }

    for (i = 0; i < variants.length; i += 1) {
      var title = normalizeOption(variants[i].productVariantTitle);
      if (title.indexOf(normalized) !== -1 || normalized.indexOf(title) !== -1) {
        match = variants[i];
        break;
      }
    }

    return match;
  }

  function resolveSkioBoxVariantIdFromConfig(skioBox, config) {
    var fromSkio = skioBox && parseShopifyGid(skioBox.platformId);
    if (fromSkio) return fromSkio;
    if (config && config.boxVariantId != null) return Number(config.boxVariantId);
    return null;
  }

  function validateTabFlSkioSelection(skioBox, selectionRoot, config) {
    if (!skioBox || !selectionRoot || !config) return;

    var total = getTotalQuantity(selectionRoot, config.key);
    if (skioBox.size != null && total !== skioBox.size) {
      throw new Error(
        'This box requires exactly ' + skioBox.size + ' flavors (selected ' + total + ').'
      );
    }
  }

  function getSkioCacheKey(boxVariantId, sellingPlanId) {
    return String(boxVariantId) + '|' + String(sellingPlanId);
  }

  function getSkioSelectableVariants(skioBox) {
    var source = skioBox || cachedSkioBox;
    var variants = source && source.selectableProductVariants;
    return Array.isArray(variants) ? variants : [];
  }

  function formatSkioFlavorTitles(skioBox) {
    return getSkioSelectableVariants(skioBox)
      .map(function (variant) {
        return variant && variant.productVariantTitle;
      })
      .filter(Boolean)
      .join(', ');
  }

  function tabFlVariantMappingError(skioBox, flavorKey) {
    return (
      'Could not map flavor to variant id. Check data-option-' +
      flavorKey +
      '-fl values match Skio flavors: ' +
      formatSkioFlavorTitles(skioBox)
    );
  }

  function fetchSkioBoxConfig(boxVariantId, sellingPlanId) {
    var variantPlatformId = String(
      boxVariantId != null ? boxVariantId : SKIO_BOX_VARIANT_ID || cachedBoxVariantId || SKIO_BOX_PRODUCT_ID
    );
    var planPlatformId = String(sellingPlanId != null ? sellingPlanId : SKIO_SELLING_PLAN_ID);
    var cacheKey = getSkioCacheKey(variantPlatformId, planPlatformId);

    if (cachedSkioBoxes[cacheKey]) {
      cachedSkioBox = cachedSkioBoxes[cacheKey];
      return Promise.resolve(cachedSkioBoxes[cacheKey]);
    }

    if (cachedSkioBoxPromises[cacheKey]) {
      return cachedSkioBoxPromises[cacheKey];
    }

    cachedSkioBoxPromises[cacheKey] = fetch('https://api.skio.com/storefront-http/get-classic-box-v2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productVariantPlatformId: variantPlatformId,
        sellingPlanPlatformId: planPlatformId,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data.ok || !data.ClassicBoxV2) {
          throw new Error('Skio box config not found for variant ' + variantPlatformId);
        }

        cachedSkioBoxes[cacheKey] = data.ClassicBoxV2;
        cachedSkioBox = cachedSkioBoxes[cacheKey];

        if (variantPlatformId === String(SKIO_BOX_VARIANT_ID)) {
          cachedBoxVariantId =
            parseShopifyGid(cachedSkioBox.platformId) || Number(SKIO_BOX_VARIANT_ID);
        }

        return cachedSkioBoxes[cacheKey];
      })
      .finally(function () {
        delete cachedSkioBoxPromises[cacheKey];
      });

    return cachedSkioBoxPromises[cacheKey];
  }

  function getReploProducts() {
    var jsonEl = document.getElementById('replo-deps-products');
    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      // console.error('subs.js: failed to parse replo-deps-products', error);
      return [];
    }
  }

  function getSkioBoxVariantIdSync(productId) {
    var products = getReploProducts();
    var targetProductId = String(productId || SKIO_BOX_PRODUCT_ID);

    for (var i = 0; i < products.length; i++) {
      var entry = products[i];
      if (String(entry.id) !== targetProductId) continue;
      if (entry.data && entry.data.variants && entry.data.variants.length) {
        return entry.data.variants[0].id;
      }
    }

    return null;
  }

  function resolveSkioBoxVariantId(boxVariantId, productId, sellingPlanId) {
    if (boxVariantId != null) {
      return Promise.resolve(Number(boxVariantId));
    }

    if (cachedBoxVariantId && productId == null) {
      return Promise.resolve(cachedBoxVariantId);
    }

    if (SKIO_BOX_VARIANT_ID && productId == null) {
      cachedBoxVariantId = Number(SKIO_BOX_VARIANT_ID);
      return Promise.resolve(cachedBoxVariantId);
    }

    var fromReplo = getSkioBoxVariantIdSync(productId);
    if (fromReplo) {
      if (productId == null) {
        cachedBoxVariantId = fromReplo;
      }
      return Promise.resolve(fromReplo);
    }

    return fetchSkioBoxConfig(boxVariantId, sellingPlanId).then(function (box) {
      var resolved = parseShopifyGid(box.platformId);
      if (productId == null) {
        cachedBoxVariantId = resolved;
      }
      return resolved;
    });
  }

  function parseCartAddResponse(response) {
    return response.text().then(function (text) {
      var data = {};

      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error('Cart add invalid response: ' + text.slice(0, 300));
        }
      }

      if (!response.ok || data.status) {
        var details =
          data.description ||
          data.message ||
          (data.errors && JSON.stringify(data.errors)) ||
          JSON.stringify(data);

        if (String(details).indexOf('Cannot find variant') !== -1) {
          throw new Error(
            'Skio box variant ' +
              SKIO_BOX_VARIANT_ID +
              ' is not available on Online Store. In Shopify Admin open product "' +
              (cachedSkioBox && cachedSkioBox.title ? cachedSkioBox.title : '2 Bags (60 Sticks)') +
              '" (ID ' +
              SKIO_BOX_PRODUCT_ID +
              ') and publish it to the Online Store sales channel.'
          );
        }

        if (String(details).toLowerCase().indexOf('sold out') !== -1) {
          throw new Error(
            'Skio box product is marked as sold out. In Shopify Admin open "' +
              (cachedSkioBox && cachedSkioBox.title ? cachedSkioBox.title : '2 Bags (60 Sticks)') +
              '" → Inventory: enable "Continue selling when out of stock" or set quantity > 0. ' +
              'For Skio static box, parent product usually should not block sales when child flavors are in stock.'
          );
        }

        throw new Error(details + ' (HTTP ' + response.status + ')');
      }

      return data;
    });
  }

  function cartAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart_add_url) {
      return window.theme.routes.cart_add_url;
    }

    return ((window.Shopify && window.Shopify.routes.root) || '/') + 'cart/add';
  }

  function buildCartAddFormData(boxVariantId, properties, sellingPlanId) {
    var formData = new FormData();

    formData.append('id', String(boxVariantId));
    formData.append('quantity', '1');
    formData.append(
      'selling_plan',
      String(sellingPlanId != null ? sellingPlanId : SKIO_SELLING_PLAN_ID)
    );

    Object.keys(properties).forEach(function (key) {
      formData.append('properties[' + key + ']', properties[key]);
    });

    return formData;
  }

  function buildSubscriptionCartFormData(variantId, sellingPlanId) {
    var formData = new FormData();

    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    formData.append('selling_plan', String(sellingPlanId));

    return formData;
  }

  function buildOneTimeCartFormData(lineItems) {
    var formData = new FormData();
    if (!lineItems || !lineItems.length) return formData;

    if (lineItems.length === 1) {
      formData.append('id', String(lineItems[0].id));
      formData.append('quantity', String(lineItems[0].quantity));
      return formData;
    }

    lineItems.forEach(function (item, index) {
      formData.append('items[' + index + '][id]', String(item.id));
      formData.append('items[' + index + '][quantity]', String(item.quantity));
    });

    return formData;
  }

  function getSelectedFlavorLineItems(root, flavorKey, skioBox) {
    var totals = {};
    if (!root) return [];

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      if (!parts.optionEl) return;

      var option1Value = getOptionFlName(parts.optionEl, flavorKey);
      var variantId = getVariantIdByOption(option1Value, skioBox);
      var qty = readQuantity(parts.quantity);

      if (!variantId || qty <= 0) return;

      totals[variantId] = (totals[variantId] || 0) + qty;
    });

    return Object.keys(totals).map(function (id) {
      return { id: Number(id), quantity: totals[id] };
    });
  }

  function getOptionFlName(optionEl, flavorKey) {
    if (!optionEl) return '';
    flavorKey = flavorKey || '2';
    return (
      optionEl.getAttribute('data-option-' + flavorKey + '-fl') || optionEl.textContent || ''
    ).trim();
  }

  function getSelectedBoxProperties(root, skioBox, flavorKey) {
    var properties = { _isClassicBoxV2: 'true' };
    if (!root) return properties;
    flavorKey = flavorKey || '2';

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      if (!parts.optionEl) return;

      var option1Value = getOptionFlName(parts.optionEl, flavorKey);
      var variantId = getVariantIdByOption(option1Value, skioBox);
      var qty = readQuantity(parts.quantity);

      if (!variantId || qty <= 0) return;

      var pvgidKey = '_pvgid://shopify/ProductVariant/' + variantId;
      var currentQty = parseInt(properties[pvgidKey], 10) || 0;
      properties[pvgidKey] = String(currentQty + qty);

      if (option1Value) {
        var labelQty = parseInt(properties[option1Value], 10) || 0;
        properties[option1Value] = String(labelQty + qty);
      }
    });

    return properties;
  }

  function getSelectedVariantIds(root, skioBox, flavorKey) {
    var selected = [];
    if (!root) return selected;
    flavorKey = flavorKey || '2';

    forEachFlContainers(root, flavorKey, function (container) {
      var parts = getContainerParts(container, flavorKey);
      if (!parts.optionEl) return;

      var option1Value = getOptionFlName(parts.optionEl, flavorKey);
      var variantId = getVariantIdByOption(option1Value, skioBox);
      var qty = readQuantity(parts.quantity);

      for (var i = 0; i < qty; i += 1) {
        selected.push(variantId);
      }
    });

    return selected;
  }

  function refreshThemeCart(response, button) {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    document.dispatchEvent(
      new CustomEvent('theme:product:add', {
        bubbles: true,
        detail: {
          response: response,
          button: button,
        },
      })
    );
  }

  function addSkioStaticBoxToCart(button) {
    if (isAddingToCart) return Promise.resolve();

    var ol2 = document.querySelector('[data-ol-2-fl]');
    if (!ol2) return Promise.resolve();

    var total = getTotalQuantity(ol2);
    if (total < MAX_BOX_TOTAL) return Promise.resolve();

    isAddingToCart = true;
    var atcRoot = button.closest('[data-atc-2-fl]') || button;

    if (button) {
      button.classList.add('loading');
    }
    setAtcDisabled(atcRoot, true);

    return fetchSkioBoxConfig(SKIO_BOX_VARIANT_ID, SKIO_SELLING_PLAN_ID)
      .then(function (skioBox) {
        var properties = getSelectedBoxProperties(ol2, skioBox, '2');
        var hasChildVariants = Object.keys(properties).some(function (key) {
          return key.indexOf('_pvgid://shopify/ProductVariant/') === 0;
        });

        if (!hasChildVariants) {
          return Promise.resolve();
        }

        return resolveSkioBoxVariantId(
          SKIO_BOX_VARIANT_ID,
          SKIO_BOX_PRODUCT_ID,
          SKIO_SELLING_PLAN_ID
        ).then(function (boxVariantId) {
          var childVariants = getSelectedVariantIds(ol2, skioBox, '2');

          if (childVariants.some(function (id) { return !id; })) {
            throw new Error(tabFlVariantMappingError(skioBox, '2'));
          }

          return fetch(cartAddUrl(), {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript',
            },
            body: buildCartAddFormData(boxVariantId, properties, SKIO_SELLING_PLAN_ID),
          }).then(parseCartAddResponse);
        });
      })
      .then(function (data) {
        // console.log('[subs.js] Skio box added to cart', {
        //   boxVariantId: cachedBoxVariantId,
        //   sellingPlanId: SKIO_SELLING_PLAN_ID,
        //   childVariants: getSelectedVariantIds(ol2),
        //   properties: properties,
        // });
        refreshThemeCart(data, button);
      })
      .catch(function (error) {
        // console.error('[subs.js] add to cart failed', error);
        // window.alert(error.message || 'Could not add to cart');
      })
      .finally(function () {
        isAddingToCart = false;

        if (button) {
          button.classList.remove('loading');
        }

        updateAtc2SelectionState();
      });
  }

  function getIntervalSelectSellingPlanId() {
    var select = document.querySelector('select.subs-select[name="interval-select"]');
    if (!select || !select.value) return null;
    return select.value;
  }

  function maybePreloadTabFlSkioBox(config) {
    var sellingPlanId = getIntervalSelectSellingPlanId();
    if (!sellingPlanId || !config) return;

    fetchSkioBoxConfig(config.boxVariantId, sellingPlanId).catch(function () {
      // console.warn('subs.js: tab ' + config.key + '-fl Skio preload failed');
    });
  }

  var TAB1_FL_CONFIG = {
    key: '1',
    panelSelector: '[data-tab-cont-1-fl]',
    tabMarker: '[data-tab-1-fl]',
    atcSelector: '[data-atc-1-fl]',
  };

  function getTabConfigByKey(key) {
    if (key === '1') return TAB1_FL_CONFIG;
    return TAB_FL_CONFIGS[key] || null;
  }

  function isTabConfigSkioBox(config) {
    return !!(config && config.boxVariantId != null);
  }

  function getTab1PanelVariantId(panel) {
    if (!panel) return null;

    var tabPanel = panel.matches('[data-tab-cont-1-fl]')
      ? panel
      : panel.querySelector('[data-tab-cont-1-fl]');
    if (!tabPanel) return null;

    var raw = tabPanel.getAttribute('data-tab-cont-1-fl');
    if (!raw || raw === 'true' || raw === 'false') return null;

    return parseShopifyGid(raw);
  }

  function addTab1FlToCart(button, panel) {
    if (isAddingToCart || !panel) return Promise.resolve();

    syncIntervalSelect('1');

    var sellingPlanId = getIntervalSelectSellingPlanId();
    if (!sellingPlanId) return Promise.resolve();

    var variantId = getTab1PanelVariantId(panel);
    if (!variantId) return Promise.resolve();

    isAddingToCart = true;

    if (button) {
      button.classList.add('loading');
    }

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: buildSubscriptionCartFormData(variantId, sellingPlanId),
    })
      .then(parseCartAddResponse)
      .then(function (data) {
        if (data) {
          refreshThemeCart(data, button);
        }
      })
      .catch(function (error) {
        console.error('[subs.js] tab 1-fl add to cart failed', error);
      })
      .finally(function () {
        isAddingToCart = false;

        if (button) {
          button.classList.remove('loading');
        }
      });
  }

  function isOneTimeHeaderExpanded() {
    var oneHeader = document.querySelector('[data-one-header]');
    return !!(oneHeader && oneHeader.getAttribute('aria-expanded') === 'true');
  }

  function getOneTimeLineItemsForTab(tabKey) {
    var panel;
    var config;
    var root;

    if (tabKey === '1') {
      panel = document.querySelector(TAB1_FL_CONFIG.panelSelector);
      if (!panel || !isTabContFlActive(panel, TAB1_FL_CONFIG)) return null;

      var variantId = getTab1PanelVariantId(panel);
      if (!variantId) return null;

      return [{ id: variantId, quantity: 1 }];
    }

    config = getTabFlConfig(tabKey);
    panel = config ? getTabFlPanel(config) : null;
    root = panel ? getTabFlRoot(panel, config) : null;

    if (
      !config ||
      !panel ||
      !root ||
      !isTabContFlActive(panel, config) ||
      getTotalQuantity(root, config.key) < config.maxTotal
    ) {
      return null;
    }

    var lineItems = getSelectedFlavorLineItems(root, config.key, null);
    if (!lineItems.length) return null;

    var totalUnits = 0;
    lineItems.forEach(function (item) {
      totalUnits += item.quantity;
    });

    if (totalUnits < config.maxTotal) return null;

    return lineItems;
  }

  function addOneTimeToCart(button, tabKey) {
    if (isAddingToCart || !tabKey || !isOneTimeHeaderExpanded()) return Promise.resolve();

    var lineItems = getOneTimeLineItemsForTab(tabKey);
    if (!lineItems || !lineItems.length) return Promise.resolve();

    isAddingToCart = true;

    if (button) {
      button.classList.add('loading');
    }

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: buildOneTimeCartFormData(lineItems),
    })
      .then(parseCartAddResponse)
      .then(function (data) {
        if (data) {
          refreshThemeCart(data, button);
        }
      })
      .catch(function (error) {
        console.error('[subs.js] one-time add to cart failed (tab ' + tabKey + ')', error);
      })
      .finally(function () {
        isAddingToCart = false;

        if (button) {
          button.classList.remove('loading');
        }
      });
  }

  function addTabFlSkioBoxToCart(button, selectionRoot, config) {
    if (isAddingToCart || !selectionRoot || !config) return Promise.resolve();

    syncIntervalSelect(config.key);

    var sellingPlanId = getIntervalSelectSellingPlanId();
    if (!sellingPlanId) return Promise.resolve();

    var total = getTotalQuantity(selectionRoot, config.key);
    if (total < config.maxTotal) return Promise.resolve();

    isAddingToCart = true;
    var atcRoot = button.closest(config.atcSelector) || button;

    if (button) {
      button.classList.add('loading');
    }
    setAtcDisabled(atcRoot, true);

    return fetchSkioBoxConfig(config.boxVariantId, sellingPlanId)
      .then(function (skioBox) {
        validateTabFlSkioSelection(skioBox, selectionRoot, config);

        var properties = getSelectedBoxProperties(selectionRoot, skioBox, config.key);
        var hasChildVariants = Object.keys(properties).some(function (key) {
          return key.indexOf('_pvgid://shopify/ProductVariant/') === 0;
        });

        if (!hasChildVariants) {
          return Promise.resolve();
        }

        var boxVariantId = resolveSkioBoxVariantIdFromConfig(skioBox, config);
        if (!boxVariantId) {
          throw new Error(
            'Skio box variant id missing for product ' + config.boxProductId
          );
        }

        var childVariants = getSelectedVariantIds(selectionRoot, skioBox, config.key);

        if (childVariants.some(function (id) { return !id; })) {
          throw new Error(tabFlVariantMappingError(skioBox, config.key));
        }

        var cartSellingPlanId =
          (skioBox.sellingPlan && parseShopifyGid(skioBox.sellingPlan)) || sellingPlanId;

        return fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: buildCartAddFormData(boxVariantId, properties, cartSellingPlanId),
        }).then(parseCartAddResponse);
      })
      .then(function (data) {
        if (data) {
          refreshThemeCart(data, button);
        }
      })
      .catch(function (error) {
        console.error('[subs.js] tab ' + config.key + '-fl add to cart failed', error);
      })
      .finally(function () {
        isAddingToCart = false;

        if (button) {
          button.classList.remove('loading');
        }

        updateTabFlAtcState(config);
      });
  }

  function getProductVariants() {
    var jsonEl = document.getElementById('replo-deps-template-product');
    if (!jsonEl) return [];

    try {
      var product = JSON.parse(jsonEl.textContent);
      return (product.data && product.data.variants) || product.variants || [];
    } catch (error) {
      // console.error('subs.js: failed to parse replo-deps-template-product', error);
      return [];
    }
  }

  function getAllReploVariants() {
    var variants = [];
    var seen = {};

    getReploProducts().forEach(function (entry) {
      if (!entry.data || !entry.data.variants) return;

      entry.data.variants.forEach(function (variant) {
        if (seen[variant.id]) return;
        seen[variant.id] = true;
        variants.push(variant);
      });
    });

    getProductVariants().forEach(function (variant) {
      if (seen[variant.id]) return;
      seen[variant.id] = true;
      variants.push(variant);
    });

    return variants;
  }

  function getVariantIdByOption(option1Value, skioBox) {
    if (!option1Value) return null;

    if (skioBox) {
      var skioMatch = findSkioVariantByOption(skioBox, option1Value);
      return skioMatch ? parseShopifyGid(skioMatch.platformId) : null;
    }

    var normalized = normalizeOption(option1Value);

    var skioVariant = getSkioSelectableVariants().find(function (variant) {
      return normalizeOption(variant.productVariantTitle) === normalized;
    });

    if (skioVariant) {
      return parseShopifyGid(skioVariant.platformId);
    }

    var variant = getAllReploVariants().find(function (entry) {
      return normalizeOption(entry.option1) === normalized;
    });

    return variant ? variant.id : null;
  }

  function logSelectedVariants(ol2) {
    // var selected = getSelectedVariantIds(ol2);
    // console.log('[subs.js] selected variant ids:', selected[0] || null, selected[1] || null);
    // console.log('[subs.js] selected variant ids (full):', selected);
  }

  function changeContainerQuantity(container, delta) {
    var ol2 = container.closest('[data-ol-2-fl]');
    if (!ol2) return;

    var parts = getContainerParts(container);
    if (!parts.quantity) return;

    var current = readQuantity(parts.quantity);
    var total = getTotalQuantity(ol2);
    var next = current + delta;

    if (delta > 0 && (total >= MAX_BOX_TOTAL || current >= MAX_BOX_ITEM)) return;
    if (delta < 0 && current <= 0) return;

    withDomLock(function () {
      writeQuantity(parts.quantity, next);
      updateBoxControls(ol2);
      updateAtc2SelectionState();
    });
    logSelectedVariants(ol2);
  }

  function initBoxSelector() {
    var ol2 = document.querySelector('[data-ol-2-fl]');
    if (!ol2) return;

    withDomLock(function () {
      rememberInitialCaptions(getElements().atc2);

      if (!ol2.dataset.subsQtyInit) {
        ol2.dataset.subsQtyInit = 'true';

        ol2.querySelectorAll('[data-2-fl-container]').forEach(function (container) {
          var parts = getContainerParts(container);
          if (!parts.quantity) return;
          if (!parts.quantity.textContent || !/^\s*\d+\s*$/.test(parts.quantity.textContent)) {
            writeQuantity(parts.quantity, 0);
          }
        });
      }

      updateBoxControls(ol2);
      updateAtc2SelectionState();
    });

    if (boxSelectorBound) return;
    boxSelectorBound = true;

    document.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-plus-2-fl]');
      var minus = event.target.closest('[data-minus-2-fl]');

      if (plus || minus) {
        var ol2Click = event.target.closest('[data-ol-2-fl]');
        if (!ol2Click) return;

        var container = event.target.closest('[data-2-fl-container]');
        if (!container) return;

        event.preventDefault();
        event.stopPropagation();
        changeContainerQuantity(container, plus ? 1 : -1);
        return;
      }

      var atc2 = event.target.closest('[data-atc-2-fl]');
      if (!atc2) return;

      var clickTarget = getAtcClickTarget(atc2) || atc2;
      if (
        clickTarget.getAttribute('aria-disabled') === 'true' ||
        clickTarget.disabled ||
        isAddingToCart
      ) {
        return;
      }

      var ol2 = document.querySelector('[data-ol-2-fl]');
      if (!ol2 || getTotalQuantity(ol2) < MAX_BOX_TOTAL) return;

      event.preventDefault();
      event.stopPropagation();
      addSkioStaticBoxToCart(clickTarget);
    });
  }

  function hasQuantityTabs() {
    return !!document.querySelector('[data-quantity-tabs]');
  }

  function getQuantityTabsAtcButtons() {
    return {
      atcOneTime: document.querySelectorAll('[data-atc-one-time]'),
      atc1: document.querySelectorAll('[data-atc-1-fl]'),
      atc2: document.querySelectorAll('[data-atc-2-fl]'),
      atc3: document.querySelectorAll('[data-atc-3-fl]'),
    };
  }

  function elementContainsMarker(el, selector) {
    if (!el) return false;
    return el.matches(selector) || !!el.querySelector(selector);
  }

  var ONE_TIME_ATC_DEFAULTS = {
    '1': 'Add to cart',
    '2': 'Pick 2 flavours',
    '3': 'Pick 3 flavours',
  };

  var TAB_DISPLAY_PRICES = {
    '1': { subActual: 25, subCompare: 30, oneActual: 30, subServing: 'Only 83p per serving' },
    '2': { subActual: 40, subCompare: 60, oneActual: 60, subServing: 'Only 66p per serving' },
    '3': { subActual: 55, subCompare: 90, oneActual: 90, subServing: 'Only 61p per serving' },
  };

  var TAB_FL_INTERVAL_PLAN_IDS = {
    '1': {
      'Every 4 weeks': '691059491155',
      'Every 6 weeks': '691059523923',
      'Every 8 weeks': '691059556691',
      'Every 12 weeks': '691068207443',
    },
    '2': {
      'Every 4 weeks': '691059065171',
      'Every 6 weeks': '691059097939',
      'Every 8 weeks': '691059130707',
      'Every 12 weeks': '691068240211',
    },
    '3': {
      'Every 4 weeks': '691059261779',
      'Every 6 weeks': '691059294547',
      'Every 8 weeks': '691059327315',
      'Every 12 weeks': '691068272979',
    },
  };

  var TAB_FL_CONFIGS = {
    '2': {
      key: '2',
      panelSelector: '[data-tab-cont-2-fl]',
      tabMarker: '[data-tab-2-fl]',
      atcSelector: '[data-atc-2-fl]',
      maxTotal: 2,
      maxItem: 2,
      boxProductId: TAB2_FL_SKIO_BOX_PRODUCT_ID,
      boxVariantId: TAB2_FL_SKIO_BOX_VARIANT_ID,
      qtyInitAttr: 'subsTab2QtyInit',
      observedAttr: 'subsTab2Observed',
    },
    '3': {
      key: '3',
      panelSelector: '[data-tab-cont-3-fl]',
      tabMarker: '[data-tab-3-fl]',
      atcSelector: '[data-atc-3-fl]',
      maxTotal: 3,
      maxItem: 3,
      boxProductId: TAB3_FL_SKIO_BOX_PRODUCT_ID,
      boxVariantId: TAB3_FL_SKIO_BOX_VARIANT_ID,
      qtyInitAttr: 'subsTab3QtyInit',
      observedAttr: 'subsTab3Observed',
    },
  };

  function getTabFlConfig(key) {
    return TAB_FL_CONFIGS[key] || null;
  }

  function getDefaultIntervalWeeksForTab(tabKey) {
    if (tabKey === '3') return 12;
    if (tabKey === '2') return 8;
    return 4;
  }

  function selectIntervalWeeks(select, weeks) {
    if (!select) return;

    var weeksStr = String(weeks);
    var i;

    for (i = 0; i < select.options.length; i += 1) {
      var label = select.options[i].textContent.trim().toLowerCase();
      if (label.indexOf(weeksStr) !== -1 && label.indexOf('week') !== -1) {
        if (select.selectedIndex !== i) {
          select.selectedIndex = i;
        }
        return;
      }
    }
  }

  function syncIntervalForActiveTab() {
    if (intervalUserChanged) return;

    var select = document.querySelector('select.subs-select[name="interval-select"]');
    if (!select) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var tabKey = getActiveQuantityTabKey(quantityTabs) || '3';
    selectIntervalWeeks(select, getDefaultIntervalWeeksForTab(tabKey));
  }

  function applyDefaultQuantityTab() {
    if (quantityTabUserChanged) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    if (!quantityTabs) return;
    if (getActiveQuantityTabKey(quantityTabs) === '3') return;

    var tab3Inner = quantityTabs.querySelector('[data-tab-3-fl]');
    if (!tab3Inner) return;

    var tab3Button = tab3Inner.closest('[role="tab"]') || tab3Inner.closest('button');
    if (!tab3Button) return;

    tab3Button.click();
    requestAnimationFrame(syncIntervalForActiveTab);
  }

  function bindIntervalSelect() {
    var select = document.querySelector('select.subs-select[name="interval-select"]');
    if (!select) return;

    syncIntervalForActiveTab();

    if (select.dataset.subsIntervalBound) return;

    select.dataset.subsIntervalBound = 'true';
    select.addEventListener('change', function () {
      intervalUserChanged = true;
      var quantityTabs = document.querySelector('[data-quantity-tabs]');
      var subHeader = document.querySelector('[data-sub-header]');
      var activeKey = getActiveSubscriptionAtcKey(quantityTabs, subHeader);
      var config = getTabConfigByKey(activeKey);
      if (config && isTabConfigSkioBox(config)) {
        maybePreloadTabFlSkioBox(config);
      }
    });
  }

  function resolveIntervalPlanId(planIds, label) {
    if (!planIds || !label) return '';

    if (planIds[label]) return planIds[label];

    var normalized = normalizeOption(label);
    var keys = Object.keys(planIds);
    var i;

    for (i = 0; i < keys.length; i += 1) {
      if (normalizeOption(keys[i]) === normalized) {
        return planIds[keys[i]];
      }
    }

    if (normalized.indexOf('4') !== -1 && normalized.indexOf('week') !== -1) {
      return planIds['Every 4 weeks'] || '';
    }
    if (normalized.indexOf('6') !== -1 && normalized.indexOf('week') !== -1) {
      return planIds['Every 6 weeks'] || '';
    }
    if (normalized.indexOf('8') !== -1 && normalized.indexOf('week') !== -1) {
      return planIds['Every 8 weeks'] || '';
    }
    if (normalized.indexOf('12') !== -1 && normalized.indexOf('week') !== -1) {
      return planIds['Every 12 weeks'] || '';
    }

    return '';
  }

  function syncIntervalSelect(activeSubKey) {
    var select = document.querySelector('select.subs-select[name="interval-select"]');
    if (!select) return;

    var planIds = TAB_FL_INTERVAL_PLAN_IDS[activeSubKey];

    Array.prototype.forEach.call(select.options, function (option) {
      var label = option.textContent.trim();
      option.value = resolveIntervalPlanId(planIds, label);
    });

    var config = getTabConfigByKey(activeSubKey);
    if (config && isTabConfigSkioBox(config)) {
      maybePreloadTabFlSkioBox(config);
    }

    syncIntervalForActiveTab();
  }

  function getActiveQuantityTabKey(quantityTabs) {
    if (!quantityTabs) return null;

    var selectedTab = quantityTabs.querySelector(
      '[role="tab"][aria-selected="true"], button[aria-selected="true"]'
    );
    if (!selectedTab) return null;
    if (elementContainsMarker(selectedTab, '[data-tab-1-fl]')) return '1';
    if (elementContainsMarker(selectedTab, '[data-tab-2-fl]')) return '2';
    if (elementContainsMarker(selectedTab, '[data-tab-3-fl]')) return '3';
    return null;
  }

  function getActiveSubscriptionAtcKey(quantityTabs, subHeader) {
    if (!quantityTabs || !subHeader) return null;
    if (subHeader.getAttribute('aria-expanded') !== 'true') return null;

    return getActiveQuantityTabKey(quantityTabs);
  }

  function getPriceDisplayElement(root) {
    if (!root) return null;
    return root.querySelector('p') || root.querySelector('span') || root;
  }

  function getCurrencyPrefixFromPriceText(text) {
    var match = String(text || '').trim().match(/^([^\d\s]+)/);
    return match ? match[1] : '£';
  }

  function formatTabPrice(amount, templateText) {
    return getCurrencyPrefixFromPriceText(templateText) + amount;
  }

  function setTabPriceOnElement(element, amount) {
    if (!element || amount == null) return;

    var displayEl = getPriceDisplayElement(element);
    if (!displayEl) return;

    var nextText = formatTabPrice(amount, displayEl.textContent);
    if (displayEl.textContent !== nextText) {
      displayEl.textContent = nextText;
    }
  }
  
  function setTabPerServingOnElement(element, amount) {
    if (!element || amount == null) return;

    var displayEl = getPriceDisplayElement(element);
    if (!displayEl) return;

    var nextText = amount;
    if (displayEl.textContent !== nextText) {
      displayEl.textContent = nextText;
    }
  }

  function syncTabDisplayPrices() {
    if (!hasQuantityTabs()) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var tabKey = getActiveQuantityTabKey(quantityTabs);
    var prices = tabKey && TAB_DISPLAY_PRICES[tabKey];
    if (!prices) return;

    document.querySelectorAll('[data-sub-actual-price]').forEach(function (el) {
      setTabPriceOnElement(el, prices.subActual);
    });
    
    document.querySelectorAll('[data-per-serving-cont]').forEach(function (el) {
      setTabPerServingOnElement(el, prices.subServing);
    });

    document.querySelectorAll('[data-sub-compare-price]').forEach(function (el) {
      setTabPriceOnElement(el, prices.subCompare);
    });

    document.querySelectorAll('[data-one-actual-price]').forEach(function (el) {
      setTabPriceOnElement(el, prices.oneActual);
    });
  }

  function syncQuantityTabsAtc() {
    if (!hasQuantityTabs()) return;

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var subHeader = document.querySelector('[data-sub-header]');
    var oneHeader = document.querySelector('[data-one-header]');
    var buttons = getQuantityTabsAtcButtons();
    var oneTimeExpanded =
      oneHeader && oneHeader.getAttribute('aria-expanded') === 'true';
    var activeSubKey = getActiveSubscriptionAtcKey(quantityTabs, subHeader);

    withDomLock(function () {
      setDisplay(buttons.atcOneTime, 'none');
      setDisplay(buttons.atc1, 'none');
      setDisplay(buttons.atc2, 'none');
      setDisplay(buttons.atc3, 'none');

      if (oneTimeExpanded) {
        setDisplay(buttons.atcOneTime, 'flex');
      }

      if (activeSubKey === '1') setDisplay(buttons.atc1, 'flex');
      if (activeSubKey === '2') setDisplay(buttons.atc2, 'flex');
      if (activeSubKey === '3') setDisplay(buttons.atc3, 'flex');

      updateAllTabFlAtcStates();
      updateOneTimeAtcState();
      syncTabDisplayPrices();
      syncIntervalSelect(activeSubKey);
    });
  }

  function updateOneTimeAtcState() {
    var atcButtons = document.querySelectorAll('[data-atc-one-time]');
    if (!atcButtons.length) return;

    if (!isOneTimeHeaderExpanded()) {
      atcButtons.forEach(function (atc) {
        setAtcDisabled(atc, true);
      });
      return;
    }

    var quantityTabs = document.querySelector('[data-quantity-tabs]');
    var tabKey = getActiveQuantityTabKey(quantityTabs);
    var defaultText = (tabKey && ONE_TIME_ATC_DEFAULTS[tabKey]) || '';

    atcButtons.forEach(function (atc) {
      var captionEl = getCaptionParagraph(atc);
      var nextText = defaultText;
      var disabled = true;

      if (tabKey === '1') {
        var panel1 = document.querySelector(TAB1_FL_CONFIG.panelSelector);
        if (panel1 && isTabContFlActive(panel1, TAB1_FL_CONFIG)) {
          nextText = 'Add to cart';
          disabled = !getTab1PanelVariantId(panel1);
        }
      } else if (tabKey === '2' || tabKey === '3') {
        var boxConfig = getTabFlConfig(tabKey);
        var panel = boxConfig ? getTabFlPanel(boxConfig) : null;
        if (panel && isTabContFlActive(panel, boxConfig)) {
          var root = getTabFlRoot(panel, boxConfig);
          var total = getTotalQuantity(root, boxConfig.key);
          nextText = getCaptionTextForBox(total, boxConfig.maxTotal, ONE_TIME_ATC_DEFAULTS[tabKey]);
          disabled = total < boxConfig.maxTotal;
        }
      }

      if (captionEl && captionEl.textContent !== nextText) {
        captionEl.textContent = nextText;
      }

      setAtcDisabled(atc, disabled);
    });
  }

  function observeTab1VariantAttr() {
    var panel = document.querySelector('[data-tab-cont-1-fl]');
    if (!panel || panel.dataset.subsTab1VariantObserved) return;

    panel.dataset.subsTab1VariantObserved = 'true';

    new MutationObserver(function () {
      if (isApplying) return;
      updateOneTimeAtcState();
    }).observe(panel, {
      attributes: true,
      attributeFilter: ['data-tab-cont-1-fl'],
    });
  }

  function bindQuantityTabs() {
    if (quantityTabsBound) {
      bindIntervalSelect();
      syncQuantityTabsAtc();
      syncAllTabFlStates();
      observeTab1VariantAttr();
      return;
    }

    quantityTabsBound = true;
    bindIntervalSelect();
    syncQuantityTabsAtc();

    document.addEventListener(
      'click',
      function (event) {
        if (!hasQuantityTabs()) return;

        var plus = event.target.closest('[data-plus-2-fl], [data-plus-3-fl]');
        var minus = event.target.closest('[data-minus-2-fl], [data-minus-3-fl]');

        if (plus || minus) {
          var qtyContainer = event.target.closest('[data-2-fl-container], [data-3-fl-container]');
          if (!qtyContainer) return;

          var tabContent =
            qtyContainer.closest('[data-tab-cont-2-fl]') ||
            qtyContainer.closest('[data-tab-cont-3-fl]');
          if (!tabContent) return;

          var config = getTabFlConfig(
            qtyContainer.matches('[data-3-fl-container]') ? '3' : '2'
          );
          if (!config || !isTabContFlActive(tabContent, config)) return;
          if (!tabContent.contains(qtyContainer)) return;

          event.stopPropagation();
          changeTabFlQuantity(qtyContainer, plus ? 1 : -1, config);
          return;
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      if (!hasQuantityTabs()) return;

      var atcOneTime = event.target.closest('[data-atc-one-time]');
      if (atcOneTime) {
        var clickTargetOne = getAtcClickTarget(atcOneTime) || atcOneTime;
        if (
          clickTargetOne.getAttribute('aria-disabled') === 'true' ||
          clickTargetOne.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (isOneTimeHeaderExpanded()) {
          var quantityTabsOne = document.querySelector('[data-quantity-tabs]');
          var oneTimeTabKey = getActiveQuantityTabKey(quantityTabsOne);

          if (oneTimeTabKey && getOneTimeLineItemsForTab(oneTimeTabKey)) {
            event.preventDefault();
            event.stopPropagation();
            addOneTimeToCart(clickTargetOne, oneTimeTabKey);
          }
        }
        return;
      }

      var atc1 = event.target.closest('[data-atc-1-fl]');
      if (atc1) {
        var clickTarget1 = getAtcClickTarget(atc1) || atc1;
        if (
          clickTarget1.getAttribute('aria-disabled') === 'true' ||
          clickTarget1.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var panel1 = document.querySelector(TAB1_FL_CONFIG.panelSelector);
        if (
          panel1 &&
          isTabContFlActive(panel1, TAB1_FL_CONFIG) &&
          getTab1PanelVariantId(panel1)
        ) {
          syncIntervalSelect('1');
          if (!getIntervalSelectSellingPlanId()) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          addTab1FlToCart(clickTarget1, panel1);
        }
        return;
      }

      var atcFl = event.target.closest('[data-atc-2-fl], [data-atc-3-fl]');
      if (atcFl) {
        var clickTarget = getAtcClickTarget(atcFl) || atcFl;
        if (
          clickTarget.getAttribute('aria-disabled') === 'true' ||
          clickTarget.disabled ||
          isAddingToCart
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var config = getTabFlConfig(atcFl.matches('[data-atc-2-fl]') ? '2' : '3');
        var panel = config ? getTabFlPanel(config) : null;
        var root = panel ? getTabFlRoot(panel, config) : null;
        if (
          config &&
          panel &&
          isTabContFlActive(panel, config) &&
          root &&
          getTotalQuantity(root, config.key) >= config.maxTotal
        ) {
          syncIntervalSelect(config.key);
          if (!getIntervalSelectSellingPlanId()) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          addTabFlSkioBoxToCart(clickTarget, root, config);
        }
        return;
      }

      if (
        event.target.closest('[data-one-header]') ||
        event.target.closest('[data-sub-header]') ||
        event.target.closest('[data-quantity-tabs] [role="tab"]') ||
        event.target.closest('[data-quantity-tabs] button[aria-selected]')
      ) {
        requestAnimationFrame(function () {
          syncQuantityTabsAtc();
          syncAllTabFlStates();
          updateOneTimeAtcState();
          syncTabDisplayPrices();
          syncIntervalForActiveTab();
        });
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        if (!hasQuantityTabs() || !event.isTrusted) return;

        if (
          event.target.closest('[data-tab-1-fl]') ||
          event.target.closest('[data-tab-2-fl]') ||
          event.target.closest('[data-tab-3-fl]') ||
          event.target.closest('[data-quantity-tabs] [role="tab"]')
        ) {
          quantityTabUserChanged = true;
          if (!intervalUserChanged) {
            requestAnimationFrame(syncIntervalForActiveTab);
          }
        }
      },
      true
    );

    new MutationObserver(function (mutations) {
      if (isApplying) return;

      var needsSync = mutations.some(function (mutation) {
        if (mutation.type !== 'attributes') return false;
        if (
          mutation.attributeName !== 'aria-expanded' &&
          mutation.attributeName !== 'aria-selected' &&
          mutation.attributeName !== 'data-state' &&
          mutation.attributeName !== 'data-tab-cont-1-fl'
        ) {
          return false;
        }

        var target = mutation.target;
        if (!target.matches) return false;

        if (
          target.matches('[data-sub-header]') ||
          target.matches('[data-one-header]') ||
          !!target.closest('[data-sub-header]') ||
          !!target.closest('[data-one-header]') ||
          !!target.closest('[data-quantity-tabs]')
        ) {
          return true;
        }

        return false;
      });

      if (needsSync) {
        syncQuantityTabsAtc();
        syncAllTabFlStates();
        syncTabDisplayPrices();
        syncIntervalForActiveTab();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded', 'aria-selected', 'data-state'],
    });
  }

  function getTabFlPanel(config) {
    return config ? document.querySelector(config.panelSelector) : null;
  }

  function isTabFlTriggerSelected(quantityTabs, config) {
    if (!quantityTabs || !config) return false;

    var selectedTab = quantityTabs.querySelector(
      '[role="tab"][aria-selected="true"], button[aria-selected="true"]'
    );
    return !!(selectedTab && elementContainsMarker(selectedTab, config.tabMarker));
  }

  function getTabFlTabpanel(panel) {
    if (!panel) return null;
    return panel.closest('[role="tabpanel"]') || panel.parentElement;
  }

  function isTabContFlActive(panel, config) {
    if (!panel || !config) return false;

    var tabpanel = getTabFlTabpanel(panel);
    if (!tabpanel || tabpanel.getAttribute('data-state') !== 'active') return false;

    var quantityTabs =
      panel.closest('[data-quantity-tabs]') ||
      document.querySelector('[data-quantity-tabs]');
    if (quantityTabs && !isTabFlTriggerSelected(quantityTabs, config)) return false;

    return true;
  }

  function getTabFlRoot(panel, config) {
    if (!panel || !config) return null;
    return panel.querySelector('[data-ol-' + config.key + '-fl]') || panel;
  }

  function getTabFlLimits(config) {
    return { maxTotal: config.maxTotal, maxItem: config.maxItem };
  }

  function logTabFlSelection(panel, config) {
    var root = getTabFlRoot(panel, config);
    if (!root) return;

    forEachFlContainers(root, config.key, function (container) {
      var parts = getContainerParts(container, config.key);
      var qty = readQuantity(parts.quantity);
      if (qty <= 0) return;

      var optionEl =
        parts.optionEl || container.querySelector(getFlPartSelector(config.key, 'option'));
      var name = getOptionFlName(optionEl, config.key);
      var variantId = name ? getVariantIdByOption(name) : null;

      console.log('subs.js [tab ' + config.key + '-fl]: выбран вариант', {
        id: variantId,
        name: name || null,
        quantity: qty,
      });
    });
  }

  function resetTabFlQuantities(panel, config) {
    var root = getTabFlRoot(panel, config);
    if (!root) return;

    withDomLock(function () {
      forEachFlContainers(root, config.key, function (container) {
        var parts = getContainerParts(container, config.key);
        writeQuantity(parts.quantity, 0);
      });
      updateBoxControls(root, getTabFlLimits(config), config.key);
    });
  }

  function initTabFlQuantities(panel, config) {
    var root = getTabFlRoot(panel, config);
    if (!root || panel.dataset[config.qtyInitAttr]) return;

    panel.dataset[config.qtyInitAttr] = 'true';

    forEachFlContainers(root, config.key, function (container) {
      var parts = getContainerParts(container, config.key);
      if (!parts.quantity) return;
      writeQuantity(parts.quantity, readQuantity(parts.quantity));
    });
  }

  function changeTabFlQuantity(container, delta, config) {
    if (!container || !config) return;
    if (!container.matches(getFlContainerSelector(config.key))) return;

    var panel = container.closest(config.panelSelector);
    if (!panel || !isTabContFlActive(panel, config)) return;

    var root = getTabFlRoot(panel, config);
    var parts = getContainerParts(container, config.key);
    if (!root || !parts.quantity) return;

    var limits = getTabFlLimits(config);
    var current = readQuantity(parts.quantity);
    var total = getTotalQuantity(root, config.key);
    var next = current + delta;

    if (delta > 0 && (total >= limits.maxTotal || current >= limits.maxItem)) return;
    if (delta < 0 && current <= 0) return;

    withDomLock(function () {
      writeQuantity(parts.quantity, next);
      updateBoxControls(root, limits, config.key);
      updateTabFlAtcState(config);
      updateOneTimeAtcState();
    });
    logTabFlSelection(panel, config);
  }

  function updateTabFlAtcState(config) {
    if (!config) return;

    var panel = getTabFlPanel(config);
    var atcButtons = document.querySelectorAll(config.atcSelector);
    var total = 0;

    if (panel && isTabContFlActive(panel, config)) {
      total = getTotalQuantity(getTabFlRoot(panel, config), config.key);
    }

    rememberInitialCaptions(atcButtons);

    atcButtons.forEach(function (atc) {
      var captionEl = getCaptionParagraph(atc);
      if (!captionEl) return;

      var initialText = initialCaptions.get(atc) || captionEl.textContent.trim();
      var nextText = getCaptionTextForBox(total, config.maxTotal, initialText);

      if (captionEl.textContent !== nextText) {
        captionEl.textContent = nextText;
      }

      setAtcDisabled(atc, total < config.maxTotal);
    });
  }

  function updateAllTabFlAtcStates() {
    updateTabFlAtcState(TAB_FL_CONFIGS['2']);
    updateTabFlAtcState(TAB_FL_CONFIGS['3']);
    updateOneTimeAtcState();
  }

  function syncTabFlState(config) {
    if (!hasQuantityTabs() || !config) return;

    var panel = getTabFlPanel(config);
    if (!panel) return;

    observeTabFlPanel(panel, config);

    if (!isTabContFlActive(panel, config)) {
      resetTabFlQuantities(panel, config);
      updateTabFlAtcState(config);
      updateOneTimeAtcState();
      return;
    }

    withDomLock(function () {
      initTabFlQuantities(panel, config);
      updateBoxControls(getTabFlRoot(panel, config), getTabFlLimits(config), config.key);
      updateTabFlAtcState(config);
      updateOneTimeAtcState();
    });
  }

  function syncAllTabFlStates() {
    syncTabFlState(TAB_FL_CONFIGS['2']);
    syncTabFlState(TAB_FL_CONFIGS['3']);
  }

  function observeTabFlPanel(panel, config) {
    if (!panel || !config || panel.dataset[config.observedAttr]) return;
    panel.dataset[config.observedAttr] = 'true';

    var tabpanel = getTabFlTabpanel(panel);
    var targets = [panel];
    if (tabpanel) targets.push(tabpanel);

    targets.forEach(function (target) {
      new MutationObserver(function () {
        if (isApplying) return;
        syncTabFlState(config);
      }).observe(target, {
        attributes: true,
        attributeFilter: ['data-state', 'hidden', 'aria-hidden'],
      });
    });
  }

  function bindQuantityTabFl(config) {
    if (!config) return;

    var panel = getTabFlPanel(config);

    if (quantityTabFlBound[config.key]) {
      syncTabFlState(config);
      return;
    }

    quantityTabFlBound[config.key] = true;
    if (panel) observeTabFlPanel(panel, config);
    syncTabFlState(config);
  }

  function initQuantityTabs() {
    if (!hasQuantityTabs()) return;
    bindQuantityTabs();
    bindQuantityTabFl(TAB_FL_CONFIGS['2']);
    bindQuantityTabFl(TAB_FL_CONFIGS['3']);
    observeTab1VariantAttr();
    updateOneTimeAtcState();
    syncTabDisplayPrices();
  }

  function init() {
    if (isApplying) return;

    applyDefaultQuantityTab();
    bindIntervalSelect();

    if (hasQuantityTabs()) {
      initQuantityTabs();
      return;
    }

    var els = getElements();
    if (!els.toggle && !els.ol2 && !els.atc1.length && !els.atc2.length) return;

    bindToggle(els.toggle);
    sync();
    initBoxSelector();
    fetchSkioBoxConfig().catch(function (error) {
      // console.warn('subs.js: Skio box preload failed', error);
    });
  }

  scheduleInit();
  document.addEventListener('DOMContentLoaded', scheduleInit);
  window.addEventListener('load', scheduleInit);

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-60-days-2-fl]')) return;
    requestAnimationFrame(sync);
  });

  new MutationObserver(function (mutations) {
    if (isApplying) return;

    var needsInit = mutations.some(mutationIsRelevant);
    if (needsInit) {
      scheduleInit();
      return;
    }

    var affectsToggle = mutations.some(function (mutation) {
      if (mutation.type !== 'attributes') return false;
      var target = mutation.target;
      return (
        target.matches &&
        (target.matches('[data-60-days-2-fl]') ||
          !!target.closest('[data-60-days-2-fl]'))
      );
    });

    if (affectsToggle) sync();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded'],
  });
})();
